import React from 'react'
import tw from 'twin.macro'

import AppLink from './app-link'

const FoundationContainer = tw.aside`bg-ql-light px-4`
const FoundationContent = tw.div`container mx-auto flex flex-col md:flex-row my-8 md:items-center`
const FoundationHeading = tw.h3`text-2xl md:w-1/3 text-ql-blue`
const FoundationBody = tw.div`flex-1`

const DocFoundation = () => (
  <FoundationContainer>
    <FoundationContent>
      <FoundationHeading>Question or Feedback?</FoundationHeading>
      <FoundationBody>Need additional help or want to make a suggestion or comment? Contact us at <AppLink href="to:MobileAppSupport@frontierscience.org">MobileAppSupport@frontierscience.org</AppLink></FoundationBody>
    </FoundationContent>
  </FoundationContainer>
)

export default DocFoundation
